
const getCurrentVersion = () => {
  return document.getElementById('currentVersion').value;
}

export { getCurrentVersion }
